import React, { useMemo } from "react";
import { logout, getUsername } from "../../services/auth";
import ModuleShellHeader from "../common/ModuleShellHeader";
import type { ModuleTab, AlertBadge } from "../common/ModuleShellHeader";
import { useI18n } from "../../i18n/I18nProvider";
// Keep legacy CSS for any overrides
import "./ManagerModuleHeader.css";

export type ManagerModuleTab =
  | "dashboard"
  | "billing"
  | "inventory"
  | "consultants"
  | "labs"
  | "reports"
  | "patients"
  | "notes"
  | "stats"
  | "ledgers";

export default function ManagerModuleHeader({
  activeTab,
  onSelectTab,
  lowStockCount,
}: {
  activeTab: ManagerModuleTab;
  onSelectTab: (_tab: ManagerModuleTab) => void;
  lowStockCount: number;
}) {
  const { t } = useI18n();
  const username = getUsername() || t("manager_role_default");

  const tabs = useMemo(
    (): ModuleTab<ManagerModuleTab>[] => [
      { key: "dashboard",   label: t("manager_tab_dashboard"),       icon: "dashboard" },
      { key: "billing",     label: t("manager_tab_billing"),         icon: "billing" },
      { key: "inventory",   label: t("manager_tab_inventory"),       icon: "stock" },
      { key: "consultants", label: t("manager_tab_consultants"),     icon: "consultant" },
      { key: "labs",        label: t("manager_tab_labs"),            icon: "lab" },
      { key: "reports",     label: t("manager_tab_finance_reports"), icon: "report" },
      { key: "patients",    label: t("manager_tab_patient_history"), icon: "patient" },
      { key: "notes",       label: t("manager_tab_clinic_notes"),    icon: "notes" },
      { key: "stats",       label: "📊 Statistics",                  icon: "report" },
      { key: "ledgers",     label: "📒 Ledgers",                     icon: "report" },
    ],
    [t]
  );

  const alerts: AlertBadge[] = [
    {
      key: "stock",
      label: t("manager_alert_low_stock"),
      count: lowStockCount,
      icon: "stock",
      badgeColor: lowStockCount > 0 ? "#f59e0b" : undefined,
      onClick: () => onSelectTab("inventory"),
    },
  ];

  return (
    <ModuleShellHeader<ManagerModuleTab>
      theme="manager"
      brandName={t("manager_brand_name")}
      brandSub={t("manager_brand_sub")}
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onSelectTab}
      alerts={alerts}
      user={{ name: username, role: t("manager_role_default") }}
      onLogout={() => { logout(); window.location.href = "/"; }}
      showDate
    />
  );
}
